import React from 'react'
import { Title, Stack } from '@mantine/core'
import { Brand } from "../../../types"
import NotesSummary from "../../../components/NotesSummary/NotesSummary"
import VehicleList from "../shared/components/VehicleList"

type AdminBrandsShowProps = {
  brand: Brand
}

const AdminBrandsShow: React.FC<AdminBrandsShowProps> = (props) => {
  const { brand } = props

  return (
    <Stack gap="xl">
      <Title order={2}>{brand.title}</Title>
      <NotesSummary notes={brand.notes || {}} />
      <VehicleList vehicles={brand.vehicle_versions || []} />
    </Stack>
  )
}

export default AdminBrandsShow
